import React, { Fragment, useEffect } from 'react';
import ReactDOM from 'react-dom';
import ModalClose from '../../modals/ModalClose';
import StepButton from '../StepButton';
import alertTriangle from '../../../assets/images/icons/alert-triangle.svg';

interface PosIdentConfirmModalProps {
	title: string;
	message: string;
	warning: string;
	confirmLabel: string;
	waitLabel: string;
	onConfirm: () => void;
	onCancel: () => void;
}

const portalElement = document.getElementById('overlays') as Element;
const appElement = document.getElementById('root') as HTMLElement;

const PosIdentConfirmModal = ({
	title,
	message,
	warning,
	confirmLabel,
	waitLabel,
	onConfirm,
	onCancel
}: PosIdentConfirmModalProps) => {
	useEffect(() => {
		appElement.style.overflowY = 'hidden';
		return () => {
			appElement.style.overflowY = 'auto';
		};
	}, []);

	return (
		<Fragment>
			{ReactDOM.createPortal(<div className="backdrop" onClick={onCancel} />, portalElement)}
			{ReactDOM.createPortal(
				<div className="modal">
					<div className="modal-content">
						<ModalClose onClose={onCancel} />
						<div className="flex flex-col items-center text-center gap-3 px-2 pb-2 w-full">
							<p className="text-lg font-[700] text-gray-800">{title}</p>
							<p className="text-sm text-gray-600 whitespace-pre-line">{message}</p>
							<div className="flex items-start gap-2 rounded-md border border-red-100 bg-red-50 p-2.5 text-left w-full">
								<img src={alertTriangle} alt="" className="mt-0.5 h-4 w-4 flex-shrink-0" />
								<span className="text-xs text-red-700">{warning}</span>
							</div>
							<StepButton disabled={false} title={waitLabel} onClick={onCancel} />
							<button
								onClick={onConfirm}
								className="text-sm font-[500] text-gray-700 underline hover:text-gray-900 focus:outline-none"
							>
								{confirmLabel}
							</button>
						</div>
					</div>
				</div>,
				portalElement
			)}
		</Fragment>
	);
};

export default PosIdentConfirmModal;
